import { InputLabel, Box, Autocomplete, TextField, Chip, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import BaseButton from '../UI/BaseButton/BaseButton';
import { 
    getSystemStatus, 
    AssignDeassignRoles } from "../../util/API/admin";
import { getCRMUsers, updateUserProfileStatus } from '../../util/API/customers';
import { useSelector } from 'react-redux';
import { changeUserDetails, changeUserStatus } from '../../util/API/admin';
import CustomAlert from '../UI/CustomAlert/CustomAlert';
import { GetCustomerData } from '../../util/API/customers';

const CRMRoleTab = ({ setRoleChanged, setProfileStatusChanged, updateTableStatus, roleChanged, handleSelectedUser, selectedUser }) => {
    const [status, setStatus] = useState(''); 
    const [securityRole, setSecurityRole] = useState(''); 
    const [profileStatus, setProfileStatus] = useState(''); 
    const [statusList, setStatusList] = useState([]);
    const [securityRolesList, setSecurityRolesList] = useState([]);
    const [profileStatusList, setProfileStatusList] = useState([]);
    const [users, setUsers] = useState([]);
    const [alert, setAlert] = useState({
        showAlert: false,
        message: "",
        severity: "",
        header: "",
      });
    const [userRoles, setUserRoles] = useState([]);
    const [triggerGetRoles, setTriggerGetRoles] = useState(false);

    const requiredConstants = useSelector((state) => state.constants);

    let user = useSelector((state) => state.usersList.userID);
    // console.log(user)

    console.log(userRoles)

    const getRoles = async () => {
        if (!triggerGetRoles) setTriggerGetRoles(true)

        const response3 = await GetCustomerData(user['User'].id)
        const userSecurityRole = response3?.Securityuserrole;
      
        if (Array.isArray(userSecurityRole)) {
          const roles = userSecurityRole.flatMap(role =>
            securityRolesList.filter(
              systemRole => systemRole.value === role.roleid
            )
          );
          setUserRoles(roles || []);
        } else if (userSecurityRole && typeof userSecurityRole === 'object') {
            console.log(securityRolesList)
          const role = securityRolesList.filter(
            systemRole => systemRole.value === userSecurityRole?.roleid
          );
          console.log(role)
          setUserRoles(role || []);
        } else {
          setUserRoles([]);
        }
      };
    
      useEffect(() => {
        if (securityRolesList.length > 0) {
            getRoles();
        }
    }, [securityRolesList, roleChanged, triggerGetRoles]); 

      useEffect(() => {
        systemRoles();
        profileStatuses();
      }, [])

    const securityRoleLogin = useSelector((state) => state.login.securityRole);
    const crmUser = useSelector((state) => state.usersList.userID);

    const handleStatusChange = (value) => {
        setStatus(value);
    };

    // const handleSecurityRoleChange = (value) => {
    //     setSecurityRole(value);
    // };

    const handleProfileStatusChange = (value) => {
        setProfileStatus(value);
    };

    const systemStatus = async() => {
        const response = await getSystemStatus();
        console.log(response)
        setStatusList(response.RunQuery4Class.data.body.payload);
    };

    const systemRoles = async () => 
    {
        const allRoles = requiredConstants.systemRoles || [];
      
        const transformedRoles = allRoles.map(role => ({
          key: role.securityrole.roleid,
          value: role.securityrole.roleid,
          label: role.securityrole.name,
        }));
      
        setSecurityRolesList(transformedRoles);
      
    };

    const profileStatuses = async () => 
    {
        const allStatus = requiredConstants.profileStatus || [];

        const transformedStatus = allStatus.map(status => ({
          key: status.userprofilestatus.statusID,
          value: status.userprofilestatus.statusID,
          label: status.userprofilestatus.name,
        }));
      
        setProfileStatusList(transformedStatus);
      
    };

    const crmRoles = async() => {
        const response = await getCRMUsers();
        setUsers(response.data.body.record);
    };

    useEffect(() => {
        systemStatus();
        crmRoles();

        if (crmUser && crmUser['User']) {
            setStatus(crmUser['User'].status); 
            const securityRole = crmUser['Securityuserrole'];
        
            if (Array.isArray(securityRole)) {
                setSecurityRole(securityRole[0].roleid); 
            } else if (securityRole && typeof securityRole === 'object') {
                setSecurityRole(securityRole.roleid);
            } else {
                console.log("No valid security role found");
            }
            
            if(crmUser?.User?.profilestatus) {
                setProfileStatus(crmUser?.User?.profilestatus);
            }
        }
    }, [crmUser, securityRoleLogin]);

    const changeStatus = async(e) => {
        e.preventDefault();
        try {
            const listData = `status|1`;
    
            const response2 = await changeUserStatus(crmUser['User'].id, listData, status);

            if (response2.payload.callStatus == "1") {
                setAlert({
                    showAlert: true,
                    message:
                      "Status has been updated successfully",
                    severity: "success",
                    header: "Success",
                });

            }
        }
        catch(error) {
            console.log(error);
            setAlert({
                showAlert: true,
                message:
                  "There was an error in updating status. " + error,
                severity: "error",
                header: "Error",
              });
        }
    }

    const addRole = async(e) => {
        e.preventDefault();
        try {
            const response = await AssignDeassignRoles(crmUser['User'].id, securityRole, 1);
    
            if (response.PartnerAddRemoveRoleClass.data.header.callStatus == "1") {
                setAlert({
                    showAlert: true,
                    message:
                      "Security Role has been added to user successfully",
                    severity: "success",
                    header: "Success",
                  });

                setRoleChanged(true);
                setTriggerGetRoles(!triggerGetRoles);
            }
        }
        catch(error) {
            console.log(error);
            setAlert({
                showAlert: true,
                message:
                  "There was an error in updating security role. " + error,
                severity: "error",
                header: "Error",
              });
        }
    };

    const handleUpdateProfileStatus = async(e) => {
        e.preventDefault();
        try {
            const list = `profilestatus|${profileStatus}`;
            const response = await updateUserProfileStatus(crmUser['User']?.id, list);
            if(response?.payload?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "User profile status has been updated successfully",
                    severity: "success",
                    header: "Success",
                });
                setProfileStatusChanged(true);
            }
        } catch (error) {
            console.log(error);
            setAlert({
                showAlert: true,
                message:
                  "There was an error in updating profile status. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const assignDeassign = async(merchantid, roleid) => {
        const response = await AssignDeassignRoles(merchantid, roleid, 0);
        // console.log(response)
        if (response.PartnerAddRemoveRoleClass.data.header.callStatus == "1") {
            setAlert({
                showAlert: true,
                message:"Role " + userRoles.find(role => role?.securityrole?.roleid === roleid)?.securityrole?.name + " has been removed from user successfully",
                severity: "success",
                header: "Success",
              });

              setRoleChanged(true);
              setTriggerGetRoles(!triggerGetRoles);
        }
        else {
            setAlert({
                showAlert: true,
                message:"Role " + userRoles.find(role => role?.securityrole?.roleid === roleid)?.securityrole?.name + " could not be removed from user",
                severity: "error",
                header: "Error",
              });
        }
        return response
      }

    return (
        <div>
            <Box sx={{ mb: 3 }}>
                <InputLabel>Status:</InputLabel>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                    <Autocomplete
                        id="status"
                        disabled
                        value={statusList.find((s) => s.userstatus.statusID === status) || null}
                        options={statusList}
                        getOptionLabel={(option) => option.userstatus.name}
                        onChange={(event, newValue) =>
                            handleStatusChange(newValue ? newValue.userstatus.statusID : "")
                        }
                        sx={{
                            flexGrow: 1,
                            height: '40px', 
                            '& .MuiInputBase-root': {
                                height: '40px', 
                                minHeight: '40px',
                                marginTop: '5px'
                            },
                        }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" fullWidth />
                        )}
                    />
                    <BaseButton 
                        buttonText="Activate User" 
                        onClick={changeStatus} 
                        className="save-button" 
                    />
                </Box>
            </Box>

            {/* <Box sx={{ mb: 3 }}>
                <InputLabel>Security Role:</InputLabel>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                    <Autocomplete
                        id="securityRole"
                        value={securityRolesList.find((role) => role.value === securityRole) || null}
                        options={securityRolesList}
                        getOptionLabel={(option) => option.label}
                        onChange={(event, newValue) =>
                            handleSecurityRoleChange(newValue ? newValue.value : "")
                        }
                        sx={{
                            flexGrow: 1,
                            height: '40px', // Ensure height matches the button
                            '& .MuiInputBase-root': {
                                height: '40px', // Align Autocomplete input height with the button
                                minHeight: '40px',
                                marginTop: '5px'
                            },
                        }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" fullWidth />
                        )}
                    />
                    <BaseButton 
                        buttonText="Add Role" 
                        onClick={addRole} 
                        className="save-button" 
                    />
                </Box>
            </Box> */}

            <Box sx={{ mb: 3 }}>
                <InputLabel>Profile Status:</InputLabel>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                    <Autocomplete
                        id="profileStatus"
                        value={profileStatusList.find((role) => role.value === profileStatus) || null}
                        options={profileStatusList}
                        getOptionLabel={(option) => option.label}
                        onChange={(event, newValue) =>
                            handleProfileStatusChange(newValue ? newValue.value : "")
                        }
                        sx={{
                            flexGrow: 1,
                            height: '40px', // Ensure height matches the button
                            '& .MuiInputBase-root': {
                                height: '40px', // Align Autocomplete input height with the button
                                minHeight: '40px',
                                marginTop: '5px'
                            },
                        }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" fullWidth />
                        )}
                    />
                    <BaseButton 
                        buttonText="Update profile status" 
                        onClick={handleUpdateProfileStatus} 
                        className="save-button" 
                    />
                </Box>
            </Box>

            <Box sx={{ mb: 3 }}>
                <Typography variant="h6">Assigned Roles:</Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        mt: 1,
                    }}
                >
                    {userRoles.length > 0 ? (
                        userRoles.map((role) => (
                            <Chip
                                key={role?.key}
                                label={role?.label}
                                // onDelete={() => {
                                //     assignDeassign(user['User']?.id, role?.key); 
                                //     updateTableStatus();
                                // }}
                                color="primary"
                                sx={{ fontSize: '0.875rem' }}
                            />
                        ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No roles assigned.
                        </Typography>
                    )}
                </Box>
            </Box>

            <CustomAlert
                severity={alert.severity}
                show={alert.showAlert}
                header={alert.header}
                message={alert.message}
                onClick={(prevDetails) => 
                    {
                        setAlert({ ...prevDetails, showAlert: false });
                        updateTableStatus();
                        handleSelectedUser(selectedUser)
                    }
                }
                autoclose={alert.severity === "error" ? false : true}
            />
        </div>
    );
};

export default CRMRoleTab;
